module.exports = __webpack_public_path__ + "images/4b9c6bda1db23d6b8f22b49702738ad1.svg";